export default __webpack_public_path__ + "assets/images/cfdcfbb4667cdef5822fdc2ca65d7cd1.png";